'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');

/* Router */

var _require = require('react-router');

var Link = _require.Link;

/* Components */
var Item = require('./item');
var Icon = require('components/ui/icon');
var TextField = require('components/ui/text-field');

var ProjectList = React.createClass({
  displayName: 'ProjectList',

  getInitialState: function getInitialState() {
    return {
      filteredProjects: null
    };
  },

  render: function render() {
    var projects = this.props.projects;
    var filteredProjects = this.state.filteredProjects;

    if (filteredProjects !== null) {
      projects = filteredProjects;
    }

    var itemNodes = projects.map(function (project) {
      return React.createElement(Item, _extends({ key: project.id }, project));
    });

    return React.createElement(
      'div',
      { className: 'list-component project-list' },
      React.createElement(
        'div',
        { className: 'toolbar' },
        React.createElement(
          Link,
          { to: '/project/new', className: 'item-component new-item-component' },
          React.createElement(Icon, { name: 'plus' })
        ),
        React.createElement(TextField, {
          placeholder: '',
          onChange: this._onSearchQueryChange })
      ),
      itemNodes
    );
  },

  _onSearchQueryChange: function _onSearchQueryChange(evt) {
    var query = evt.target.value;

    var projects = this.props.projects;

    if (query.length) {
      (function () {
        // Make query lowercase, split into words and filter out empty ones
        var queryWords = query.toLowerCase().split(' ').filter(function (word) {
          return !!word;
        });

        // Every individual word tries to find a match
        projects = projects.filter(function (project) {
          return queryWords.every(function (word) {
            return project.name.toLowerCase().includes(word);
          });
        });
      })();
    }

    this.setState({ filteredProjects: projects });
  }
});

module.exports = ProjectList;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/list.js
 **/